// extracted by mini-css-extract-plugin
export default {"container":"IP-z","topReviewHeading":"JP-z","criticalReview":"KP-z","favorableReview":"LP-z","vsSeparator":"MP-z"};